import client from './SharedConfig';

export const reportVehicleAd = ({body={}, header={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'advertisement/vehicle/report/',
        data: body,
        headers: header
    };
    return client.request(config )
};

export const deleteVehicle = ({header={}} = {}, id=0) => {
    const config = {
        method: 'DELETE',
        url: `advertisement/dashboard/vehicle/delete/${id}/`,
        headers: header
    };
    return client.request(config)
};

export const addVehicleToFavourites = ({body={}, header={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'advertisement/vehicle/favourite/add/',
        data: body,
        headers: header
    };
    return client.request(config )
};

export const removeVehicleFromFavourites = ({header={}} = {}, id=0) => {
    const config = {
        method: 'POST',
        url: `advertisement/vehicle/favourite/delete/${id}/`,
        headers: header
    };
    return client.request(config )
};

export const elevateVehicle = ({header={}} = {}, id=0) => {
    const config = {
        method: 'POST',
        url: `advertisement/dashboard/vehicle/elevate/${id}/`,
        headers: header
    };
    return client.request(config )
};

export const getUserFavouriteVehicleAdIds = ({header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/vehicle/favourite/ids/',
        headers: header
    };
    return client.request(config )
};

export const getVehiclesList = ({header={}, parameter={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/vehicle/list/',
        headers: header,
        params: parameter
    };
    return client.request(config )
};

export const getVehicleDetails = (id="0") => {
    const config = {
        method: 'GET',
        url: `advertisement/vehicle/detail/${id}/`
    };
    return client.request(config )
};

export const getVehicleBrands = ({header={}, parameter={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/vehicle/brand/list/',
        headers: header,
        params: parameter
    };
    return client.request(config )
};

export const getValidVehicles = ({header={}, parameter={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/vehicle/valid/list/',
        headers: header,
        params: parameter
    };
    return client.request(config )
};

export const getCities = ({header={}, parameter={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/cities/list/',
        headers: header,
        params: parameter
    };
    return client.request(config )
};

export const getSpecialCategories = ({header={}, parameter={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/special/category/list/',
        headers: header,
        params: parameter
    };
    return client.request(config )
};

export const createVehicleAd = ({body={}, header={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'advertisement/dashboard/vehicle/create/',
        data: body,
        headers: header
    };
    return client.request(config )
};